import styled from 'styled-components';

export const AddChoices = styled('div')`
  margin: 1rem 0;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
`;

export const ScoreFieldWrapper = styled('span')`
  flex: 0.3;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ChoiceWrapper = styled('div')`
  align-items: center;
  display: flex;
  height: 6rem;
`;
